import { z } from 'zod';
import { JsonValue, JsonValueZod } from './json.value.zod';

export type JsonSafeEntityOptions = Record<string, JsonValue>;

export const JsonSafeMetadataOptionZod = z.object({
  value: JsonValueZod,
  label: z.string(),
}).strict();

export type JsonSafeMetadataOption = z.infer<typeof JsonSafeMetadataOptionZod>;

export const JsonSafeMetadataZod = z.object({
  name: z.string().optional(),
  displayName: z.string().optional(),
  qualifiedDisplayName: z.string().optional(),
  description: z.string().optional(),
  examples: z.array(z.string()).optional(),
  placeholder: z.string().optional(),
  group: z.string().optional(),
  path: z.string().optional(),
  type: z.string().optional(),
  subtype: z.string().optional(),
  arrayOf: z.string().optional(),
  defaultValue: JsonValueZod.optional(),
  options: z.array(JsonSafeMetadataOptionZod).optional(),
  enumName: z.string().optional(),
  // JSON-safe target entity for Lookup/Parent/Site/Tag fields — the
  // ActivityEntityName the picker queries. Carried here so a pure-JSON schema
  // can tell the lookup editor which entity to load (the runtime-only
  // `typeData` shape is not JSON-safe). The lookup editor reads this FIRST,
  // then falls back to typeData.
  entity: z.string().optional(),
  identifier: z.boolean().optional(),
  icon: z.string().optional(),
  visualType: z.string().optional(),
  required: z.boolean().optional(),
  readonly: z.boolean().optional(),
  min: z.number().optional(),
  max: z.number().optional(),
  minLength: z.number().optional(),
  maxLength: z.number().optional(),
  pattern: z.string().optional(),
  step: z.number().optional(),
  editor: z.string().optional(),
  editorInputs: z.string().optional(),
  entityOptions: z.record(z.string(), JsonValueZod).optional(),
  uiOverride: z.string().optional(),
  format: z.string().optional(),
  currency: z.string().optional(),
  precision: z.number().optional(),
  locale: z.string().optional(),
  // Board/table column width in px (same meaning as MetadataEntityFieldData.columnWidth).
  columnWidth: z.number().int().positive().optional(),
}).strict();

export type JsonSafeMetadata = z.infer<typeof JsonSafeMetadataZod>;
